<template>
  <div class="test-list-root">
    <el-row style="margin-bottom: 20px">
      <el-col :offset="12" :span="12" style="text-align: right">
        <el-input
          clearable
          v-model="filterTerm"
          placeholder="请输入应用名称进行筛选"
          size="large"
          style="width: 240px; text-transform: uppercase"
        >
          <template #suffix>
            <i class="iconfont icon-sousuo"></i>
          </template>
        </el-input>
      </el-col>
    </el-row>

    <TakoPanel
      :header="false"
      style="padding: 10px 20px"
      v-loading="loadingApps"
    >
      <AppsTabs
        :curTabLabel="curTabLabel"
        :isAdmin="isAdmin"
        :tableData="projectApps"
        :tableKey="appsKey"
        :filterTerm="filterTerm"
      />
    </TakoPanel>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useProjectStore } from "@/Store/ProjectStore";
import { storeToRefs } from "pinia";
import TakoPanel from "@/Components/TakoPanel.vue";
import AppsTabs from "@/Components/AppsTabs.vue";

const projectStore = useProjectStore();

const { projectApps, loadingApps, isAdmin } = storeToRefs(projectStore);

const appsKey = [
  { name: "应用名称", prop: "appname" },
  { name: "平台", prop: "platform" },
  { name: "最新版本", prop: "releaseversion.package.version" },
  { name: "应用大小", prop: "releaseversion.package.size" },
  { name: "创建时间", prop: "createtime" },
  { name: "更新时间", prop: "updatetime" },
];

const filterTerm = ref("");
const curTabLabel = ref("all");
</script>

<style lang="scss" scoped>
.test-list-root {
  padding: 20px;
  height: 100%;
  overflow: auto;
}
</style>
